import { render, staticRenderFns } from "./decorate-form.vue?vue&type=template&id=6586de94&"
import script from "./decorate-form.vue?vue&type=script&lang=js&"
export * from "./decorate-form.vue?vue&type=script&lang=js&"
import style0 from "./decorate-form.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6586de94')) {
      api.createRecord('6586de94', component.options)
    } else {
      api.reload('6586de94', component.options)
    }
    module.hot.accept("./decorate-form.vue?vue&type=template&id=6586de94&", function () {
      api.rerender('6586de94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/approval/@fragment/decorate-form.vue"
export default component.exports